import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { testOracleEpmConnection } from '../../../../slices/source';

export const useConnectionTest = () => {
  const [testLoading, setTestLoading] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [availableVersions, setAvailableVersions] = useState([]);
  const dispatch = useDispatch();

  const handleTestConnection = async (type, hostname, username, password, database, port) => {
    // Validate required fields based on database type
    let requiredFields = [];
    if (!type) requiredFields.push('type');
    if (!hostname) requiredFields.push('hostname');
    if (!username) requiredFields.push('username');
    if (!password) requiredFields.push('password');
    
    // For non-SQLite databases, also require database and port
    if (type && type !== 'SQLite' && type !== 'OracleEPM') {
      if (!database) requiredFields.push('database');
      if (!port) requiredFields.push('port');
    }

    if (requiredFields.length > 0) {
      setTestResult({
        is_connected: false,
        message: `Please fill in all required fields: ${requiredFields.join(', ')}`
      });
      return;
    }

    setTestLoading(true);
    setTestResult(null);

    try {
      const formData = new FormData();
      formData.append('database_type', type);
      formData.append('hostname', hostname);
      formData.append('username', username);
      formData.append('password', password);
      
      // Add database and port for non-SQLite, non-Oracle EPM databases
      if (type && type !== 'SQLite' && type !== 'OracleEPM') {
        formData.append('database', database);
        formData.append('port', port);
      }

      const result = await dispatch(testOracleEpmConnection(formData)).unwrap();
      setTestResult(result);
      
      // Store available versions if connection is successful
      if (result.is_connected && result.versions) {
        setAvailableVersions(result.versions);
      } else {
        setAvailableVersions([]);
      }
    } catch (error) {
      setTestResult({
        is_connected: false,
        message: "Connection test failed",
        detail: error.message || "Unknown error occurred"
      });
    } finally {
      setTestLoading(false);
    }
  };

  const clearTestResult = () => {
    setTestResult(null);
    setAvailableVersions([]);
  };

  return {
    testLoading,
    testResult,
    availableVersions,
    handleTestConnection,
    clearTestResult,
    setTestResult
  };
};

